import { faBuildingUser, faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import { usePathViewedActivity } from '~/api/queries/pathViewed'
import { NameCircle } from '~/components/Global/Elements/NameCircle/NameCircle'
import { NotificationIndicator } from '~/components/Global/Elements/NotificationIndicator/NotificationIndicator'
import { formatRelativeTime } from '~/utils/date'
import { formatName } from '~/utils/names'
import type { ConversationItem as ConversationItemType } from '../../types'
import {
  avatar,
  avatarWrapper,
  conversationBody,
  conversationDate,
  conversationExcerpt,
  conversationHeader,
  conversationItem,
  conversationItemActive,
  conversationName,
  conversationNameDirect,
  typeIcon
} from './ConversationItem.css'

type ConversationItemProps = {
  conversation: ConversationItemType
  isActive: boolean
  showType?: boolean
  onClick: () => void
}

export const ConversationItem = ({
  conversation,
  isActive,
  showType,
  onClick
}: ConversationItemProps): ReactElement => {
  const path =
    conversation.type === 'applicant'
      ? `/messaging/applicant/${conversation.id}`
      : `/messaging/contact/${conversation.id}`

  const { hasNewActivity } = usePathViewedActivity(path)

  const fullName = formatName(conversation)
  const relativeDate = formatRelativeTime(
    new Date(conversation.lastActionDate),
    1
  )

  return (
    <button
      type="button"
      className={clsx(conversationItem, isActive && conversationItemActive)}
      onClick={onClick}
      aria-current={isActive ? 'true' : undefined}
    >
      <div className={avatarWrapper}>
        {conversation.photoUrl ? (
          <img src={conversation.photoUrl} alt={fullName} className={avatar} />
        ) : (
          <NameCircle name={fullName} size={40} />
        )}
      </div>

      <div className={conversationBody}>
        <div className={conversationHeader}>
          <span
            className={clsx(
              conversationName,
              conversation.isDirect && conversationNameDirect
            )}
          >
            {fullName}
            {showType && (
              <FontAwesomeIcon
                icon={
                  conversation.type === 'applicant' ? faUser : faBuildingUser
                }
                className={typeIcon}
              />
            )}
          </span>
          <span className={conversationDate}>{relativeDate}</span>
        </div>
        {conversation.lastMessageExcerpt && (
          <div className={conversationExcerpt}>
            {conversation.lastMessageExcerpt}
          </div>
        )}
      </div>

      {hasNewActivity && <NotificationIndicator />}
    </button>
  )
}
